import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Impact from "./pages/Impact";
import Donate from "./pages/Donate";
import UpComingEvents from "./pages/UpComingEvents";
import Blog from "./pages/Blog";
import PhotoGallery from "./pages/PhotoGallery";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import "./index.css";

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-white dark:bg-[#141414] text-gray-900 dark:text-white">
        <Navbar />
        <div className="flex-grow pt-24">
          <Routes>
            <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/events" element={<UpComingEvents />} />
            <Route path="/gallery" element={<PhotoGallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Blog />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
